import request from '@/utils/request'
import qs from 'qs'
export function login(data) {
  return request({
    url: '/api/oauth/Login',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    method: 'post',
    data: qs.stringify(data)
  })
}

export function loginDg(data) {
  return request({
    url: '/api/oauth/LoginDg',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    method: 'post',
    data: qs.stringify(data)
  })
}


export function getInfo() {
  return request({
    url: '/api/oauth/CurrentUser',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/api/oauth/Logout',
    method: 'get'
  })
}

export function getUUID() {
  return request({
    url: '/api/oauth/captcha',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {}
  })
}

export function getSysConfig(account) {
  return request({
    url: `/api/oauth/getAconfig/${account}`,
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: { fkey: 'ifSysplatsmscaptchaOpen' }
  })
}

export function sentSmscode(account, username, imgcaptcha, uuid) {
  return request({
    url: `/api/oauth/sentSmscode/${account}`,
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({ username: username,imgcaptcha:imgcaptcha,uuid:uuid })
  })
}
